import {ACTION_BUTTON_Z_INDEX} from '@components/game-room/ActionButtons';
import {TABLE_AREA_Z_INDEX} from '@constant/system';
import {EMOJI_TRANSITION_DURATION} from '@constant/game';

const commonPlayerStyle = {
  zIndex: TABLE_AREA_Z_INDEX.CHIP,
};

const TABLE_IMAGE_HEIGHT = 378;
const TABLE_IMAGE_WIDTH = 582;

const TABLE_HEIGHT_DESKTOP = 378;
const TABLE_WIDTH_DESKTOP = 582;

const EMOJI_SELECTOR_OFFSET = {
  HEIGHT: 40,
  WIDTH: 50,
};

const desktop = theme => {
  const {toVW} = theme;
  return {
    dealerButton: {
      '&.position_0': {
        left: '58%',
        top: '83%',
      },
      '&.position_1': {
        top: '30%',
        left: '10%',
      },
      '&.position_2': {
        right: '39%',
        top: 20,
      },
      '&.position_3': {
        top: '30%',
        left: '85%',
      },
    },
    tableLogo: {
      top: '47%',
    },
    cardsOnTable: {
      top: '45%',
      width: '43%',
    },
    topLeft: {
      position: 'absolute',
      transform: 'unset',
      top: '30%',
      left: '-2.5%',
    },
    topMiddle: {
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      top: '5%',
      left: '50%',
    },
    topRight: {
      position: 'absolute',
      transform: 'unset',
      top: '30%',
      right: '-2.5%',
    },
    bottomMiddle: {
      bottom: '-14%',
      left: '50%',
      transform: 'translate(-50%, 0)',
    },
    emojiTargetButton: {
      color: 'transparent',
      background: 'transparent',
      '&:hover': {
        color: 'transparent',
        background: 'transparent',
      },
      position: 'absolute',
      '&.position0': {
        // display: 'none',
        left: '44.5%',
        top: '87%',
        extend: 'emojiTargetArea',
      },
      '&.position1': {
        left: '-1%',
        top: '41%',
        extend: 'emojiTargetArea',
      },
      '&.position2': {
        left: '44.5%',
        top: '1%',
        extend: 'emojiTargetArea',
      },
      '&.position3': {
        top: '41%',
        right: '-1%',
        extend: 'emojiTargetArea',
      },
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    // for positioning player icons
    tableArea: {
      position: 'relative',
    },
    neonTable: {
      width: 582,
    },
    gameInfoArea: {
      position: 'absolute',
      fontSize: 12,
      display: 'flex',
      color: 'white',
      zIndex: 2,
      left: '50%',
      transform: 'translate(-50%,0)',
      top: '21.5%',
      opacity: 0.5,
    },
    gameMode: {
      margin: '0 5px',
    },
    multiUnitContainer: {
      '& .ant-statistic-content-prefix': {
        marginRight: 0,
      },
    },
    potArea: {
      width: '80px',
      height: '35px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#62616B 0% 0% no-repeat padding-box;',
      boxShadow: 'inset 3px 3px 5px #000000A5',
      borderRadius: '19px',
      opacity: '0.79',
      color: 'white',
      top: '27%',
      border: 'none',
      position: 'absolute',
      textAlign: 'center',
      fontSize: '12px',
      left: '50%',
      transform: 'translate(-50%, 0)',
      padding: '2px 0',
    },
    potInfoContainer: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'space-around',
      '& > div': {
        lineHeight: '105%',
      },
    },
    tableLogo: {
      position: 'absolute',
      top: '53%',
      left: '50%',
      width: 110,
      transform: 'translate(-50%, -50%)',
    },
    cardsOnTable: {
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center',
      height: 'fit-content',
      position: 'absolute',
      top: '44%',
      zIndex: ACTION_BUTTON_Z_INDEX.COMMUNITY_CARD,
      left: '50%',
      transform: 'translate(-50%, 0)',
      width: '44%',
      '& article': {
        marginRight: '2.5px',
      },
    },
    topLeft: {
      ...commonPlayerStyle,
      position: 'absolute',
      transform: 'translate(-50%, 0)',
      top: '7%',
      left: '32%',
    },
    topMiddle: {
      ...commonPlayerStyle,
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      top: '5%',
      left: '50%',
    },
    topRight: {
      ...commonPlayerStyle,
      position: 'absolute',
      top: '7%',
      right: '21%',
    },
    bottomMiddle: {
      ...commonPlayerStyle,
      position: 'absolute',
      bottom: '-10.5%',
      left: '25%',
    },
    dealerButton: {
      position: 'absolute',
      zIndex: 5,
      width: 20,
      height: 20,
      backgroundColor: '#FFF0C6',
      boxShadow: 'inset 0px -2px 0px #D0B25B;',
      display: 'flex',
      borderRadius: '50%',
      justifyContent: 'center',
      '&.position_0': {
        top: '69%',
        left: '23.5%',
      },
      '&.position_1': {
        left: '15%',
        top: 80,
      },
      '&.position_2': {
        right: '39%',
        top: 20,
      },
      '&.position_3': {
        top: 80,
        left: '79%',
      },
      '&.hidden': {
        display: 'none',
      },
    },
    dealerLabel: {
      width: 10,
      height: 10,
      position: 'relative',
      top: 3.5,
    },
    emojiTargetSelector: {
      position: 'absolute',
      width: TABLE_IMAGE_WIDTH + EMOJI_SELECTOR_OFFSET.WIDTH,
      height: TABLE_IMAGE_HEIGHT + EMOJI_SELECTOR_OFFSET.HEIGHT,
      zIndex: ACTION_BUTTON_Z_INDEX.EMOJI_TARGET_SELECT_BACKDROP,
    },
    emojiTargetSelectorBody: {
      position: 'relative',
      width: '100%',
      height: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    },
    emojiTargetDescription: {
      height: 44,
      marginTop: '28%',
      background:
        // eslint-disable-next-line max-len
        'radial-gradient(#969696, #505050E6, #1F002933)',
      width: '100%',
      textAlign: 'center',
      lineHeight: '44px',
    },
    emojiTargetArea: {
      width: 70,
      height: 100,
    },
    emojiTargetCancelButton: {
      marginTop: 10,
    },
    emojiTargetButton: {
      color: 'transparent',
      background: 'transparent',
      '&:hover': {
        color: 'transparent',
        background: 'transparent',
      },
      position: 'absolute',
      '&.position0': {
        // display: 'none',
        left: '44.5%',
        top: '87%',
        extend: 'emojiTargetArea',
      },
      '&.position1': {
        left: '22.5%',
        top: '23%',
        extend: 'emojiTargetArea',
      },
      '&.position2': {
        left: '44.5%',
        top: '5%',
        extend: 'emojiTargetArea',
      },
      '&.position3': {
        top: '23%',
        right: '23.5%',
        extend: 'emojiTargetArea',
      },
    },
    shootingEmojiContainer: {
      position: 'absolute',
      // transform: 'translate(0, 194px)',
      transform: 'translate(0, 0)',
      transition: 'transform 0s ease-out',
      zIndex: ACTION_BUTTON_Z_INDEX.EMOJI_CONTAINER,
      pointerEvents: 'none',
    },
    hidden: {
      visibility: 'hidden',
    },
    isAnimating: {
      transition: `transform ${EMOJI_TRANSITION_DURATION}ms ease-out`,
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
